/* Change only the text of Shopify's unbranded Buy it now fallback.
   Keep the payment_button markup and its native checkout event handlers intact. */
(() => {
  const selector = '#MainContent[data-template="product.reel-bundle"] shopify-buy-it-now-button > button.shopify-payment-button__button--unbranded';
  const labelButtons = () => {
    for (const button of document.querySelectorAll(selector)) {
      if (button.textContent.trim().toLowerCase() === 'buy it now') {
        button.textContent = 'Buy Now';
      }
    }
  };

  labelButtons();
  const observer = new MutationObserver(labelButtons);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
